export const INIT_SIGNIN = 'INIT_SIGNIN';
export const INIT_SIGNOUT = 'INIT_SIGNOUT';
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
export const CHANGE_FREETRIAL_STATUS = 'CHANGE_FREETRIAL_STATUS';
export const SET_TRIAL_STATUS = 'SET_TRIAL_STATUS';
export const UPDATE_EXISTING_USER_STATUS = 'UPDATE_EXISTING_USER_STATUS';
export const UPDATE_REFERRAL_MODAL = 'UPDATE_REFERRAL_MODAL';
export const UPDATE_PAYMENT_STATUS = 'UPDATE_PAYMENT_STATUS';
export const UPDATE_BACKGROUND_THEME = 'UPDATE_BACKGROUND_THEME';
export const UPDATE_STUDENT_MODAL_STATUS = 'UPDATE_STUDENT_MODAL_STATUS';
export const UPDATE_USER_LEGALNAME = 'UPDATE_USER_LEGALNAME';
export const UPDATE_USER_LOCATION_DETAILS = 'UPDATE_USER_LOCATION_DETAILS';
export const UPDATE_USER_LOCATION_FROM = 'UPDATE_USER_LOCATION_FROM';
export const UPDATE_USER_SURVEY_ANSWER = 'UPDATE_USER_SURVEY_ANSWER';
export const TOGGLE_SITE_THEME = 'TOGGLE_SITE_THEME';

export const INIT_PLAYER = 'INIT_PLAYER';
export const INIT_CHAPTER_LIST = 'INIT_CHAPTER_LIST';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_MYCOURSES = 'UPDATE_MYCOURSES';
export const UPDATE_NAME = 'UPDATE_NAME';
export const CHANGE_ACTIVE_MODULE = 'CHANGE_ACTIVE_MODULE';
export const DESTROY_PLAYER = 'DESTROY_PLAYER';
export const UPDATE_PHONE_NO_VERIFIED = 'UPDATE_PHONE_NO_VERIFIED';

export const INIT_PUZZLE = 'INIT_PUZZLE';
export const CHANGE_QUESTION = 'CHANGE_QUESTION';
export const SELECTED_OPTION = 'SELECTED_OPTION';
export const SET_PUZZLE_PROGRESSID = 'SET_PUZZLE_PROGRESSID';

export const INIT_IDE = 'INIT_IDE';
export const CHANGE_STATEMENT = 'CHANGE_STATEMENT';
export const SAVE_CODE = 'SAVE_CODE';
export const SET_CHALLENGE_PROGRESSID = 'SET_CHALLENGE_PROGRESSID';
export const SAVE_TESTCASE_RESPONSES = 'SAVE_TESTCASE_RESPONSES';
export const TESTCASE_COMPLETED = 'TESTCASE_COMPLETED';

export const START_QUIZ = 'START_QUIZ';
export const INIT_QUIZ = 'INIT_QUIZ';
export const ANSWSER_SUBMIT = 'ANSWER_SUBMIT';
export const SAVE_TESTCASE_RESPONSES_QUIZ = 'SAVE_TESTCASE_RESPONSES_QUIZ';
export const CHANGE_QUIZ_QUESTION = 'CHANGE_QUIZ_QUESTION';
export const GET_RESULT = 'GET_RESULT';
export const RESET_QUIZ = 'RESET_QUIZ';
export const UPDATE_PROBLEM_POINTS = 'UPDATE_PROBLEM_POINTS';

export const INIT_SEGMENTS = 'INIT_SEGMENTS';
export const START_SEGMENT_IMPRESSION = 'START_SEGMENT_IMPRESSION'; // Start title card
export const END_SEGMENT_IMPRESSION = 'END_SEGMENT_IMPRESSION'; // Ending card
export const SEGMENT_START = 'SEGMENT_START';
export const SEGMENT_FINISHED = 'SEGMENT_FINISHED';
export const PROGRESS_SECOND_UPDATE = 'PROGRESS_SECOND_UPDATE';
export const VIDEO_FINISHED = 'VIDEO_FINISHED';
export const VIDEO_PAUSE = 'VIDEO_PAUSE';
export const VIDEO_PLAY = 'VIDEO_PLAY';
export const VIDEO_SEEK = 'VIDEO_SEEK';

export const UPDATE_MODULE_COMPLETED = 'UPDATE_MODULE_COMPLETED';
export const INIT_POINTS_MASTER_DATA = 'INIT_POINTS_MASTER_DATA';
export const HIDE_SNACKBAR = 'HIDE_SNACKBAR';

export const SET_CURRENCY = 'SET_CURRENCY';
export const CUSTOM_PRICING_PLAN = 'CUSTOM_PRICING_PLAN';
export const CLEAR_CHECKOUT = 'CLEAR_CHECKOUT';
export const UPDATE_SIGNUP_PATH = 'UPDATE_SIGNUP_PATH';
export const UPDATE_PURCHASED_PATH = 'UPDATE_PURCHASED_PATH';
export const PRICING_PLAN = 'PRICING_PLAN';
export const UPDATE_CHECKOUT_PROMO_CODE = 'UPDATE_CHECKOUT_PROMO_CODE';
export const UPDATE_OFFER_STATUS = 'UPDATE_OFFER_STATUS';
export const UPDATE_OFFER_NAME = 'UPDATE_OFFER_NAME';

export const PAYEE_INFO = 'PAYEE_INFO';
export const UPDATE_PROMO_AMOUNT = 'UPDATE_PROMO_AMOUNT';
export const INIT_AFFILIATE_USER = 'INIT_AFFILIATE_USER';
export const REFERRAL_REDEEM_STATUS = 'REFERRAL_REDEEM_STATUS';

export const WATCHED_HINT = 'WATCHED_HINT';
export const WATCHED_SOLUTION = 'WATCHED_SOLUTION';
export const UPDATE_PROGRESS_STATE = 'UPDATE_PROGRESS_STATE';
export const INIT_PROBLEM = 'INIT_PROBLEM';
export const RESTORE_PROBLEM_STATE = 'RESTORE_PROBLEM_STATE';
export const SAVE_PROBLEM_CODE = 'SAVE_PROBLEM_CODE';
export const PROBLEM_COMPLETED_MODAL = 'PROBLEM_COMPLETED_MODAL';
export const PUZZLE_COMPLETED_MODAL = 'PUZZLE_COMPLETED_MODAL';
export const SAVE_SOLUTION = 'SAVE_SOLUTION';

export const DEVELOPMENT_ENVIRONMENT = 'DEVELOPMENT_ENVIRONMENT';
export const OTP_VERIFYID = 'OTP_VERIFYID';

export const SAVE_ALL_COURSES = 'SAVE_ALL_COURSES';
export const SAVE_IN_PROGRES_COURSES = 'SAVE_IN_PROGRES_COURSES';

export const SAVE_CHAPTER_LIST = 'SAVE_CHAPTER_LIST';
export const SAVE_MODULE_DETAILS = 'SAVE_MODULE_DETAILS';

export const SAVE_OTHER_INPROGRESS_COURSES = 'SAVE_OTHER_INPROGRESS_COURSES';
export const UPDATE_USER_SURVEY_STATUS = 'UPDATE_USER_SURVEY_STATUS';

export const SAVE_VIDEO_COMPLETE_STATUS = 'SAVE_VIDEO_COMPLETE_STATUS';
export const UPDATE_REFERRAL_PAYMENT_INFO = 'UPDATE_REFERRAL_PAYMENT_INFO';

export const SAVE_LINKEDIN_POST = 'SAVE_LINKEDIN_POST';
export const SAVE_USER_PROGRESS = 'SAVE_USER_PROGRESS';
export const SAVE_USER_PROFILE_DETAILS = 'SAVE_USER_PROFILE_DETAILS';

export const SAVE_SUBSCRIPTION_TYPE = 'SAVE_SUBSCRIPTION_TYPE';

export const SAVE_PHONENUMBER_MODEL = 'SAVE_PHONENUMBER_MODEL';

export const SAVE_COURSEUPGRADE_DATA = 'SAVE_COURSEUPGRADE_DATA';

export const SAVE_PAYMENT_GATEWAY_TYPE = 'SAVE_PAYMENT_GATEWAY_TYPE';

export const SAVE_INDIAN_CURRENCY_PLAN = 'SAVE_INDIAN_CURRENCY_PLAN';

export const SHOW_PRICING_TOGGLE = 'SHOW_PRICING_TOGGLE';

export const SET_PROMO_PERCENTAGE = 'SET_PROMO_PERCENTAGE';

export const SET_SUBSCRIPTION_PLAN = 'SET_SUBSCRIPTION_PLAN';
